"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import SearchIcon from "../../shared/icons/SearchIcon"
import { UI_STYLE_PRIMARY_BLUE_BLACK } from "../../../../../lib/constants"

// 55px yellow circular search button (was MUI IconButton + styled).
export default function SearchMagnifyingGlassIconButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Search"
      className="flex h-[55px] w-[55px] cursor-pointer items-center justify-center rounded-full bg-[#E6FF63] transition-colors hover:bg-[#c2d753]"
    >
      <SearchIcon color={UI_STYLE_PRIMARY_BLUE_BLACK} />
    </button>
  )
}
